<template>
  <input
    type="text"
    class="input-small"
    v-bind:value="value"
    v-bind:placeholder="placeholder"
    v-on:input="$emit('input', $event.target.value)"
  />
</template>
<script>
export default {
  name: 'datepicker',
  props: ['value', 'format', 'minDate', 'maxDate', 'placeholder'],
  mounted: function () {
    $(this.$el).mask(this.format ? this.format.replace(/[dm]/g, '9').replace(/[y]/g, '99') : window.i18nJS.time.formats.mask_date);
    // activate the plugin when the component is mounted.
    $(this.$el).datepicker({
      dateFormat: this.format || i18nJS.time.formats.datepicker_date,
      onClose: this.onClose,
      minDate: this.minDate,
      maxDate: this.maxDate,
    });
  },
  methods: {
    // callback for when the selector popup is closed.
    onClose(date) {
      if (date === '__/__/____' || date === '____/__/__' || date === '________') {
        date = null;
      }
      this.$emit('input', date); //maybe you need to validate something here? Dont knwo the plugin well enough.
    },
  },
  watch: {
    // when the value fo the input is changed from the parent,
    // the value prop will update, and we pass that updated value to the plugin.
    value(newVal) {
      $(this.el).datepicker('setDate', newVal);
    },
  },
};
</script>
<style scoped lang="scss">
input {
  box-sizing: unset;
}
</style>
